const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});

/** "Tue, 07 Apr 2026 06:30:04 GMT" → "7 апреля 2026" */
export function formatNewsDate(createdAt: string): string {
    return dateFormatter.format(new Date(createdAt));
}

/** HTML из редактора → плоский текст для превью. */
export function toPlainText(html: string, limit = 160): string {
    const text = html
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\uFEFF/g, '')
        .replace(/\s+/g, ' ')
        .trim();

    return text.length > limit ? `${text.slice(0, limit).trimEnd()}…` : text;
}